import { useMemo } from 'react';

import { useAppSelector } from '@src/core/hooks';
import { cartStateSelector } from '@src/features/cart/store/cart';
import { useTransactable } from '@src/features/transactables';
import { appInfoSelector } from '@src/stores/app';

import { CHECKOUT_SOURCE, type CheckoutEventProps } from '../checkoutTracking';
import { resolveCheckoutItems } from '../core/resolveCheckoutItems';
import { resolveCheckoutProducts } from '../core/resolveCheckoutProducts';

export const useCheckoutEventProps = (): CheckoutEventProps => {
  const appInfo = useAppSelector(appInfoSelector);
  const { cart } = useAppSelector(cartStateSelector);
  const transactable = useTransactable();
  const { directLink } = transactable;

  const items = useMemo(
    () => resolveCheckoutItems({ ...transactable, cartItems: cart?.items }),
    [transactable, cart?.items],
  );

  return useMemo(
    () => ({
      seller_id: appInfo?.id,
      seller_name: items[0]?.product?.app?.name ?? directLink?.app?.name,
      products: resolveCheckoutProducts(items),
      source: directLink ? CHECKOUT_SOURCE.planneLink : CHECKOUT_SOURCE.site,
      planne_link_id: directLink?.id,
      planne_link_code: directLink?.code,
    }),
    [appInfo?.id, items, directLink],
  );
};

export default useCheckoutEventProps;
